import React from 'react';
import { Field } from 'formik';

import styles from './educationFormStyles';

import EducationAutocomplete from './EducationAutocomplete/educationAutocomplete';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

const { degreeTypes, collegeMajors } = require('buyside/util/constantsFromRails.json');
import { range } from 'buyside/util/lodashAlt';

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const years = range([1930, new Date().getFullYear() + 1]);

const EducationForm = ({ isSumzeroAdmin, setFieldValue }) => {
  const renderEmployerHistory = (schoolHistoryPath, schoolHistory) => (
    <div className={styles.schoolHistoryMainArea}>
      <div className={styles.schoolHistoryRow}>
        <div className={styles.schoolHistoryColumn}>
          <EducationAutocomplete
            name={schoolHistoryPath}
            setFieldValue={setFieldValue}
            locked={!isSumzeroAdmin && !!schoolHistory.id}
          />
        </div>
      </div>
      <div className={styles.schoolHistoryRow}>
        <div className={styles.schoolHistoryColumn}>
          <Field
            component={InputField}
            name={schoolHistoryPath + '.degree'}
            type="select"
            label="Degree"
            options={[...degreeTypes.undergrad, ...degreeTypes.graduate]}
          />
        </div>
        <div className={styles.schoolHistoryColumn}>
          <Field
            component={InputField}
            name={schoolHistoryPath + '.fieldOfStudy'}
            type="select"
            label="Field Of Study"
            options={collegeMajors}
          />
        </div>
      </div>
      <div className={styles.schoolHistoryCurrentStduent}>
        <Field
          component={SingleCheckboxField}
          name={schoolHistoryPath + '.currentStudent'}
          label="I Am Currently a Student Here"
        />
      </div>
      <div className={styles.schoolHistoryRow}>
        <div className={styles.schoolHistoryColumn}>
          <Field
            component={InputField}
            name={schoolHistoryPath + '.startYear'}
            type="select"
            label="Year Started"
            options={years}
          />
        </div>
        <div className={styles.schoolHistoryColumn}>
          {!schoolHistory.currentStudent && (
            <Field
              component={InputField}
              name={schoolHistoryPath + '.gradYear'}
              type="select"
              label="Year Graduated (if not current)"
              options={years}
            />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <AddRemoveForm
      title="Schools"
      attr="userProfile.schoolHistories"
      renderItem={renderEmployerHistory}
      itemName="School"
      blankItem={{
        schoolName: '',
        degree: '',
        fieldOfStudy: '',
        currentStudent: '',
        startYear: '',
        gradYear: ''
      }}
      lockExisting
      isSumzeroAdmin={isSumzeroAdmin}
    />
  );
};

export default EducationForm;
